<template>
  <datepicker
    @input="input"
    @selected="selected"
    @closed="closed"
    @cleared="cleared"
    class="vcalendar"
    v-model="dateValue"
    :open-date="state.disabledDates.to"
    :format="dateFormat"
    :disabled-dates="state.disabledDates"
    :language="ja"
    :clear-button="clearBtn"
  >
  </datepicker>
</template>
<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'Calendar',
  components: {
    datepicker
  },
  props: {
    schedule: Object,
    value: String,
    name: {
      type: String,
      default: ''
    },
    clearBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // カレンダーの設定
      dateValue: '',
      dateFormat: 'yyyy-MM-dd',
      ja: {
        language: 'Japanese',
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        monthsAbbr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        days: ['日', '月', '火', '水', '木', '金', '土'],
        rtl: false,
        ymd: 'yyyy-MM-dd',
        yearSuffix: '年'
      },
      state: {
        disabledDates: {
          to: undefined,
          from: undefined,
          days: [],
          daysOfMonth: [],
          dates: [],
          ranges: []
        }
      }
    }
  },
  methods: {
    input: function () {
    },
    selected: function (event) {
    },
    closed: function (event) {
      if (this.name && this.name !== '') {
        this.$emit('selectedDate', this.name, this.dateValue)
      } else {
        this.$emit('selectedDate', this.dateValue)
      }
    },
    cleared: function (event) {
      this.$emit('clearedDate', this.name, this.dateValue)
      this.dateValue = ''
    }
  },
  mounted: function () {
  },
  watch: {
    schedule: function () {
      if (this.schedule.toDate) this.$set(this.state.disabledDates, 'to', moment(this.schedule.toDate).toDate())
      if (this.schedule.fromDate) this.$set(this.state.disabledDates, 'from', moment(this.schedule.fromDate).toDate())
      if (this.schedule.days) this.$set(this.state.disabledDates, 'days', this.schedule.days)
      if (this.schedule.dayOfMonth) this.$set(this.state.disabledDates, 'daysOfMonth', this.schedule.dayOfMonth)
      if (this.schedule.dates) {
        let array = []
        this.schedule.dates.forEach(d => array.push(moment(d).toDate()))
        this.$set(this.state.disabledDates, 'dates', array)
      }
      if (this.schedule.ranges) {
        let array = []
        this.schedule.ranges.forEach(d => {
          let range = {
            to: moment(d.to).toDate(),
            from: moment(d.from).toDate()
          }
          array.push(range)
        })
        this.$set(this.state.disabledDates, 'ranges', array)
      }
    }
  },
  created: function () {
    this.dateValue = this.value
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/Calendar.vue